import { render } from "./OtherServicesView.vue?vue&type=template&id=660d44ba&scoped=true"
import script from "./OtherServicesView.vue?vue&type=script&lang=js"
export * from "./OtherServicesView.vue?vue&type=script&lang=js"

import "./OtherServicesView.vue?vue&type=style&index=0&id=660d44ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660d44ba"]])

export default __exports__